module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAANpJREFUKBWdUCsOhDAUHDYbEDgEBgkXIEHgKrgJp+EUWMIFSNAIjoBA4RAEEPjCe7tL0tD9ZCdp2s68edNXQx7AH7iTZ1kWrOv6k93zPJimiRtVZ1kG27a/LsuyUJYlB3Ci4zhwXVdJzPMcvu9DCKHwlEZgo6I8L2ma6uiTYyPFN01zkp8OURQ9ZPrVY0baFAzDIKdpUji6FEXBHH+OLqHve4zjqJOY46ceLS4FSZJcOCJetQblVlWFeZ7RdR3CMNQa2rZFHMesB0HAHcgr67qWNNc70Gzbtp3yDrcLnruYt4NVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/buro.png
// module id = 493
// module chunks = 0